/**
 * Copyright (c) 2024-2026 Ronan LE MEILLAT
 * License: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import * as React from "react";
import { SVGProps } from "react";

export type IconSvgProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

export const Logo: React.FC<IconSvgProps> = React.memo(
  ({ size = 36, height = 36 }) => (
    <svg
      data-name="Calque 1"
      height={`${height}px`}
      id="prefix__Calque_1"
      viewBox="0 0 595.08 595.08"
      width={`${size}px`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <style>{`.prefix__cls-1 {fill:none}`}</style>
      </defs>
      <rect
        fill="#cd1517"
        height="184.21"
        rx="12"
        ry="12"
        transform="rotate(-45 297.538 297.546)"
        width="184.21"
        x="205.44"
        y="205.44"
      />
      <path
        className="prefix__cls-1"
        d="M426.96 324.94c7.53-7.53 17.47-11.3 27.4-11.3v101.98c0 21.31-17.44 38.75-38.75 38.75H313.63c0-9.93 3.77-19.86 11.3-27.4l102.02-102.02zM324.94 168.12c-7.53-7.53-11.3-17.47-11.3-27.4h101.98c21.31 0 38.75 17.44 38.75 38.75v101.98c-9.93 0-19.86-3.77-27.4-11.3L324.95 168.13zM270.14 426.96c7.53 7.53 11.3 17.47 11.3 27.4H179.46c-21.31 0-38.75-17.44-38.75-38.75V313.63c9.93 0 19.86 3.77 27.4 11.3l102.02 102.02zM179.47 140.72h101.98c0 9.93-3.77 19.86-11.3 27.4L168.13 270.14c-7.53 7.53-17.47 11.3-27.4 11.3V179.46c0-21.31 17.44-38.75 38.75-38.75z"
      />
      <path
        d="M454.36 415.61V313.63c9.93 0 19.86 3.77 27.4 11.3l102.02 102.02c15.07 15.07 15.07 39.73 0 54.79L481.76 583.76c-15.07 15.07-39.73 15.07-54.79 0L324.95 481.74c-7.53-7.53-11.3-17.47-11.3-27.4h101.98c21.31 0 38.75-17.44 38.75-38.75z"
        fill="#268035"
      />
      <path
        d="M270.14 113.33c7.53 7.53 11.3 17.47 11.3 27.4H179.46c-21.31 0-38.75 17.44-38.75 38.75v101.98c-9.93 0-19.86-3.77-27.4-11.3L11.3 168.12c-15.07-15.07-15.07-39.73 0-54.79L113.33 11.3c15.07-15.07 39.73-15.07 54.79 0l102.02 102.02z"
        fill="#d54a15"
      />
      <path
        d="M415.61 140.72H313.63c0-9.93 3.77-19.86 11.3-27.4L426.96 11.3c15.07-15.07 39.73-15.07 54.79 0l102.02 102.02c15.07 15.07 15.07 39.73 0 54.79L481.75 270.13c-7.53 7.53-17.47 11.3-27.4 11.3V179.45c0-21.31-17.44-38.75-38.75-38.75z"
        fill="#c61261"
      />
      <path
        d="M179.47 454.36h101.98c0 9.93-3.77 19.86-11.3 27.4L168.13 583.78c-15.07 15.07-39.73 15.07-54.79 0L11.3 481.76c-15.07-15.07-15.07-39.73 0-54.79l102.02-102.02c7.53-7.53 17.47-11.3 27.4-11.3v101.98c0 21.31 17.44 38.75 38.75 38.75z"
        fill="#54256b"
      />
      <g>
        <path
          d="M270.14 426.96c7.53 7.53 11.3 17.47 11.3 27.4H179.46c-21.31 0-38.75-17.44-38.75-38.75V313.63c9.93 0 19.86 3.77 27.4 11.3l102.02 102.02z"
          fill="#9b2b7c"
        />
        <path
          d="M324.94 426.96l102.02-102.02c7.53-7.53 17.47-11.3 27.4-11.3v101.98c0 21.31-17.44 38.75-38.75 38.75H313.63c0-9.93 3.77-19.86 11.3-27.4z"
          fill="#99b91f"
        />
        <path
          d="M168.12 270.14c-7.53 7.53-17.47 11.3-27.4 11.3V179.46c0-21.31 17.44-38.75 38.75-38.75h101.98c0 9.93-3.77 19.86-11.3 27.4L168.13 270.13z"
          fill="#efae00"
        />
        <path
          d="M454.36 179.47v101.98c-9.93 0-19.86-3.77-27.4-11.3L324.94 168.13c-7.53-7.53-11.3-17.47-11.3-27.4h101.98c21.31 0 38.75 17.44 38.75 38.75z"
          fill="#2a9086"
        />
      </g>
    </svg>
  ),
);

export const DiscordIcon: React.FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      {...props}
    >
      <path
        d="M14.82 4.26a10.14 10.14 0 0 0-.53 1.1 14.66 14.66 0 0 0-4.58 0 10.14 10.14 0 0 0-.53-1.1 16 16 0 0 0-4.13 1.3 17.33 17.33 0 0 0-3 11.59 16.6 16.6 0 0 0 5.07 2.59A12.89 12.89 0 0 0 8.23 18a9.65 9.65 0 0 1-1.71-.83 3.39 3.39 0 0 0 .42-.33 11.66 11.66 0 0 0 10.12 0q.21.18.42.33a10.84 10.84 0 0 1-1.71.84 12.41 12.41 0 0 0 1.08 1.78 16.44 16.44 0 0 0 5.06-2.59 17.22 17.22 0 0 0-3-11.59 16.09 16.09 0 0 0-4.09-1.35zM8.68 14.81a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.93 1.93 0 0 1 1.8 2 1.93 1.93 0 0 1-1.8 2zm6.64 0a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.92 1.92 0 0 1 1.8 2 1.92 1.92 0 0 1-1.8 2z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TwitterIcon: React.FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      {...props}
    >
      <path
        d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GithubIcon: React.FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M12.026 2c-5.509 0-9.974 4.465-9.974 9.974 0 4.406 2.857 8.145 6.821 9.465.499.09.679-.217.679-.481 0-.237-.008-.865-.011-1.696-2.775.602-3.361-1.338-3.361-1.338-.452-1.152-1.107-1.459-1.107-1.459-.905-.619.069-.605.069-.605 1.002.07 1.527 1.028 1.527 1.028.89 1.524 2.336 1.084 2.902.829.091-.645.351-1.085.635-1.334-2.214-.251-4.542-1.107-4.542-4.93 0-1.087.389-1.979 1.024-2.675-.101-.253-.446-1.268.099-2.64 0 0 .837-.269 2.742 1.021a9.582 9.582 0 0 1 2.496-.336 9.554 9.554 0 0 1 2.496.336c1.906-1.291 2.742-1.021 2.742-1.021.545 1.372.203 2.387.099 2.64.64.696 1.024 1.587 1.024 2.675 0 3.833-2.33 4.675-4.552 4.922.355.308.675.916.675 1.846 0 1.334-.012 2.41-.012 2.737 0 .267.178.577.687.479C19.146 20.115 22 16.379 22 11.974 22 6.465 17.535 2 12.026 2z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const MoonFilledIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <path
      d="M21.53 15.93c-.16-.27-.61-.69-1.73-.49a8.46 8.46 0 01-1.88.13 8.409 8.409 0 01-5.91-2.82 8.068 8.068 0 01-1.44-8.66c.44-1.01.13-1.54-.09-1.76s-.77-.55-1.83-.11a10.318 10.318 0 00-6.32 10.21 10.475 10.475 0 007.04 8.99 10 10 0 002.89.55c.16.01.32.02.48.02a10.5 10.5 0 008.47-4.27c.67-.93.49-1.519.32-1.79z"
      fill="currentColor"
    />
  </svg>
);

export const SunFilledIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <g fill="currentColor">
      <path d="M19 12a7 7 0 11-7-7 7 7 0 017 7z" />
      <path d="M12 22.96a.969.969 0 01-1-.96v-.08a1 1 0 012 0 1.038 1.038 0 01-1 1.04zm7.14-2.82a1.024 1.024 0 01-.71-.29l-.13-.13a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.984.984 0 01-.7.29zm-14.28 0a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a1 1 0 01-.7.29zM22 13h-.08a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zM2.08 13H2a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zm16.93-7.01a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a.984.984 0 01-.7.29zm-14.02 0a1.024 1.024 0 01-.71-.29l-.13-.14a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.97.97 0 01-.7.3zM12 3.04a.969.969 0 01-1-.96V2a1 1 0 012 0 1.038 1.038 0 01-1 1.04z" />
    </g>
  </svg>
);

export const HeartFilledIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <path
      d="M12.62 20.81c-.34.12-.9.12-1.24 0C8.48 19.82 2 15.69 2 8.69 2 5.6 4.49 3.1 7.56 3.1c1.82 0 3.43.88 4.44 2.24a5.53 5.53 0 0 1 4.44-2.24C19.51 3.1 22 5.6 22 8.69c0 7-6.48 11.13-9.38 12.12Z"
      fill="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);

export const SearchIcon = (props: IconSvgProps) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="1em"
    role="presentation"
    viewBox="0 0 24 24"
    width="1em"
    {...props}
  >
    <path
      d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M22 22L20 20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
